export const locale = {
    lang: 'pl',
    data: {
        'Online Carts': 'Koszyki online',
        'Users online': 'Użytkownicy online',
        'Resources online': 'Urządzenia online',
        'Payment': 'Płatność',
        'Created at': 'Data utworzenia',
        'Customer': 'Klient',
        'Items': 'Pozycje',
        'Paid': 'Zapłacono',
        'Yes': 'Tak',
        'No': 'Nie',
        'Payment date': 'Data płatności',
        'Paid amount': 'Zapłacona kwota',
    }
};
